import { takeLatest, all } from 'redux-saga/effects';

export function closed() {}

export default all([takeLatest('@item/CLOSE', closed)]);
